import { Injectable } from '@angular/core';
import { Route, Router, UrlSegment } from '@angular/router';

import { MingaPermission } from 'libs/domain';
import { Observable } from 'rxjs';

import { PermissionsService } from '@app/src/app/permissions';

/**
 * Guard to ensure that the user is a superadmin.
 */
@Injectable({ providedIn: 'root' })
export class SuperadminGuard {
  constructor(private _router: Router, private _permissionService: PermissionsService) {}
  canLoad(route: Route, segments: UrlSegment[]): boolean | Observable<boolean> | Promise<boolean> {
    if (!this._permissionService.hasPermission(MingaPermission.SUPERADMIN)) {
      return false;
    }
    return true;
  }
}
